export const I18N_POST_PROCESSORS = {
    decodeNbsp: 'decodeNbsp',
} as const;
